var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);

// src/constants/constants.ts
var GalleryEvents = {
  applicationLoaded: "gallery_application_loaded",
  backClicked: "gallery_back_clicked",
  error: "gallery_error",
  userInteraction: "gallery_userinteraction",
  languageChanged: "gallery_language_changed",
  exitClicked: "gallery_close_clicked",
  summaryClicked: "gallery_summary_clicked",
  preSummaryClicked: "gallery_pre_summary_clicked",
  addProducts: "gallery_add_products",
  missingProduct: "gallery_missing_product_error",
  missingProductAndExit: "gallery_missing_product_and_exit_error",
  shoppingListClicked: "gallery_shopping_list_clicked",
  handleCountdownBanner: "gallery_handle_countdown_banner",
  navigateToDesign: "gallery_navigate_to_design",
  saveDesignForLater: "gallery_save_design_for_later",
  preSaveDesignForLater: "gallery_pre_save_design_for_later"
};
var UpptackaEvents = {
  applicationLoaded: "upptacka_application_loaded",
  backClicked: "upptacka_backclicked",
  error: "upptacka_error",
  userInteraction: "upptacka_userinteraction",
  languageChanged: "upptacka_language_changed",
  exitClicked: "upptacka_closeclicked",
  summaryClicked: "upptacka_summaryclicked",
  preSummaryClicked: "upptacka_pre_summaryclicked",
  addProducts: "upptacka_addproducts",
  missingProduct: "upptacka_missing_product_error",
  missingProductAndExit: "upptacka_missing_product_and_exit_error",
  shoppingListClicked: "upptacka_shopping_list_clicked",
  handleCountdownBanner: "upptacka_handle_countdown_banner",
  navigateToDesign: "upptacka_navigate_to_design",
  saveDesignForLater: "upptacka_save_design_for_later",
  preSaveDesignForLater: "upptacka_pre_save_design_for_later"
};
var SessionStorage = {
  kioskIntegrationPlatform: "kiosk-integration-platform"
};

// src/utilities/post-message.ts
function postMessage(event, data, separator = ":") {
  window.parent.postMessage(
    {
      method: data ? `${event}${separator}${data}` : event
    },
    "*"
  );
}

// src/kiosk-integration/kiosk-integration.ts
var KioskIntegration = class {
  constructor(options) {
    __publicField(this, "platformEvents");
    __publicField(this, "debug");
    const params = new URLSearchParams(document.location.search);
    this.debug = options == null ? void 0 : options.debug;
    switch (true) {
      case ((options == null ? void 0 : options.platform) === "gallery" || params.get("ipexGallery") === "true"):
        this.platformEvents = GalleryEvents;
        sessionStorage.setItem(
          SessionStorage.kioskIntegrationPlatform,
          "gallery"
        );
        break;
      case ((options == null ? void 0 : options.platform) === "upptacka" || params.get("origin") === "upptacka"):
        this.platformEvents = UpptackaEvents;
        sessionStorage.setItem(
          SessionStorage.kioskIntegrationPlatform,
          "upptacka"
        );
        break;
      case sessionStorage.getItem(SessionStorage.kioskIntegrationPlatform) === "gallery":
        this.platformEvents = GalleryEvents;
        break;
      case sessionStorage.getItem(SessionStorage.kioskIntegrationPlatform) === "upptacka":
        this.platformEvents = UpptackaEvents;
        break;
      default:
        break;
    }
  }
  sendEvent(event, data, separator = ":") {
    if (!this.platformEvents) {
      return;
    }
    if (this.debug) {
      console.log({ event: this.platformEvents[event], data });
    }
    postMessage(this.platformEvents[event], data, separator);
  }
  addProducts(products) {
    const articles = products.map((item) => `${item.id}:${item.quantity}`).join(",");
    this.sendEvent("addProducts", articles, "=");
  }
  /**
   * Checks if kiosk print support is allowed based on the URL parameter `allowPrint`.
   * @returns {boolean} - Returns `true` if `allowPrint=true` is in the URL, otherwise `false`.
   */
  getKioskPrintSupport() {
    const params = new URLSearchParams(document.location.search);
    return params.get("allowPrint") === "true";
  }
  /**
   * Retrieves the kiosk platform based on the URL parameters.
   * @returns The kiosk platform, which can be "upptacka", "gallery", or undefined.
   */
  getKioskPlatform() {
    const params = new URLSearchParams(document.location.search);
    if (params.get("origin") === "upptacka") {
      return "upptacka";
    } else if (params.get("ipexGallery") === "true") {
      return "gallery";
    }
  }
  /**
   * Notifies that the application has loaded.
   */
  applicationLoaded() {
    this.sendEvent("applicationLoaded");
  }
  /**
   * Handles the event when the back button is clicked.
   */
  backClicked() {
    this.sendEvent("backClicked");
  }
  missingProductAndExit(error) {
    this.sendEvent("missingProductAndExit", error);
    this.sendEvent("exitClicked");
  }
  /**
   * Sends an error event with the specified error message.
   * This will make the Kiosk exit out of the application in a graceful way.
   * @param error - The error message.
   */
  error(error) {
    this.sendEvent("error", error);
  }
  /**
   * Handles user interaction. Its absence is used to detect inactivity.
   */
  userInteraction() {
    this.sendEvent("userInteraction");
  }
  /**
   * Handles the event of when you are exiting the planner.
   * Allows the kiosk platform to know that we are to close down the iframe of the senders application.
   */
  exitClicked() {
    this.sendEvent("exitClicked");
  }
  /**
   * Handles the click event on the summary.
   * @param plannerCode - The article, spr or vpc code.
   * @param type - The type of planner code. Defaults to "VPC".
   * @example kioskIntegration.summaryClicked("HFHFHF")
   */
  summaryClicked(plannerCode, type = "VPC") {
    if (!plannerCode || plannerCode.trim() === "") {
      throw new Error("planner code is mandatory but was not provided.");
    }
    this.sendEvent("summaryClicked", `${type}:${plannerCode}`, "=");
  }
  /**
   * Handles the event when the shopping list is clicked. Only handled in the Upptäcka platform.
   */
  shoppingListClicked() {
    this.sendEvent("shoppingListClicked");
  }
  /**
   * Sends an event for a missing product.
   * @param error - The error message associated with the missing product.
   */
  missingProduct(error) {
    this.sendEvent("missingProduct", error);
  }
  /**
   * Tells the kiosk platform to fully handle the countdown banner.
   * The countdown banner implemented by the kiosk platforms use the userInteraction event
   * to track the user if they are active or inactive.
   */
  handleCountdownBanner() {
    this.sendEvent("handleCountdownBanner");
  }
  /**
   * Changes the language of the kiosk platform.
   * Allows the kiosk platform to stay in sync with the language if it is changed inside an application
   * and then the user exits that application.
   * @param locale - The locale to set the language to.
   */
  languageChange(locale) {
    if (this.platformEvents === GalleryEvents) {
      this.sendEvent("languageChanged", locale);
    }
  }
  /**
   * @description Used to trigger a navigation in the kiosk platform to the provided design. Opens the relevant planner.
   * Currently not supported by Upptäcka.
   * @param designCode A valid VPC code.
   * @example kioskIntegration.navigateToDesign("HFHFHF")
   */
  navigateToDesign(designCode) {
    if (this.platformEvents === GalleryEvents) {
      this.sendEvent("navigateToDesign", designCode);
    }
  }
  /**
   * @description Used to trigger a modal where the user may save the design for later in the Upptäcka platform.
   * @param designCode - The VPC code representing the design to be delivered to Upptäcka
   * so that they may give it to the customer in various ways.
   * @example kioskIntegration.saveDesignForLater("HFHFHF")
   */
  saveDesignForLater(designCode) {
    if (this.platformEvents === UpptackaEvents) {
      this.sendEvent("saveDesignForLater", designCode);
    }
  }
  /**
   * @description Used to trigger a modal where the user may save the design for later in the Upptäcka platform.
   * @param designCode - The VPC code representing the design to be delivered to Upptäcka
   * so that they may give it to the customer in various ways.
   * @example kioskIntegration.saveDesignForLater("HFHFHF")
   */
  preSaveDesignForLater() {
    if (this.platformEvents === UpptackaEvents) {
      this.sendEvent("preSaveDesignForLater");
    }
  }
  /**
   * @description Used to trigger a modal where the user may save the design for later in the Upptäcka platform.
   * @param designCode - The VPC code representing the design to be delivered to Upptäcka
   * so that they may give it to the customer in various ways.
   * @example kioskIntegration.saveDesignForLater("HFHFHF")
   */
  preSummaryClicked() {
    if (this.platformEvents === UpptackaEvents) {
      this.sendEvent("preSummaryClicked");
    }
  }
};
export {
  GalleryEvents,
  KioskIntegration,
  SessionStorage,
  UpptackaEvents
};
